<h3 class="ui header light user-step-title">
  Additional Questions</h3>


<div *ngIf="loading.isLoading;else loaded">
  <app-loading [loadingText]="loading.text"></app-loading>
</div>

<ng-template #loaded>

  <app-load-error *ngIf="loadError; else noErrors" [loadError]="loadError">
  </app-load-error>

  <ng-template #noErrors>

    <!-- <app-action-errors *ngIf="actionErrors.length > 0" [title]="actionErrorTitle" [actionErrors]="actionErrors">
    </app-action-errors> -->

    <ng-container *ngIf="questions.length > 0; else noQuestions">

      <div class="user-step-instruction">
        Please answer the following questions about the course.
      </div>

      <div class="ui form additional-questions">
        <div *ngFor="let question of questions; let i = index;" class="additional-question-section">

          <div class="question-section">
            <div>{{i+1}}. {{question.question}}</div>
          </div>

          <div class="answer-section">

            <div *ngIf="question.format == 'text'">

              <div class="field">
                <textarea [(ngModel)]="question.textAnswer.textAnswer" rows="2" (keyup)="valueChanged()"></textarea>
              </div>

            </div>

            <div *ngIf="question.format == 'checkbox' || question.format == 'radio'">

              <div class="grouped fields" *ngIf="question.format == 'checkbox'">

                <div class="field" *ngFor="let option of question.options">
                  <div class="ui checkbox">
                    <input type="checkbox" [(ngModel)]="option.isSelected" [checked]="option.isSelected"
                      (change)="valueChanged()">
                    <label>{{option.description}}</label>
                  </div>

                  <div class="ui input other-text-input" *ngIf="option.otherTextRequired && option.isSelected">
                    <input placeholder="Please describe" type="text" [(ngModel)]="option.otherText"
                      (change)="valueChanged()" />
                  </div>

                </div>
              </div>

              <div class="grouped fields" *ngIf="question.format == 'radio'">
                <div class="field" *ngFor="let option of question.options">
                  <div class="ui radio checkbox">
                    <input type="radio" [checked]="option.isSelected" [attr.name]="'answer-option-radio-' + question.id"
                      (change)="radioSelectionChanged(question, option.id)">
                    <label>{{option.description}}</label>
                  </div>

                  <div class="ui input other-text-input" *ngIf="option.otherTextRequired && option.isSelected">
                    <input placeholder="Please describe" type="text" [(ngModel)]="option.otherText" />
                  </div>

                </div>
              </div>

            </div>

          </div>

        </div>

      </div>


      <div *ngIf="editable" class="save-button">
        <span class="status-text" *ngIf="isValueChanged && !saving">
          <i class="exclamation triangle icon"></i>Please save your changes.</span>
        <span class="status-text" *ngIf="saving">
          Saving...</span>
        <span class="status-text" *ngIf="justSaved">
          <i class="check icon"></i>Changes have been saved successfully.
        </span>
        <button class="ui button tiny primary" (click)="saveAnswers(questions)"
          [ngClass]="{'loading': saving, 'disabled': saving || !isValueChanged}">Save</button>
      </div>

    </ng-container>

  </ng-template>

  <ng-template #noQuestions>
    <div class="ui message">There are no questions about the course.</div>
  </ng-template>

</ng-template>